import { COLORS, TYPOGRAPHY } from '@app/constants';
import { ROUTES } from '@app/routers';
import { actions } from '@app/store';
import { useAppDispatch } from '@app/store/hooks';
import { BreakpointsEnum } from '@app/types';
import Button from '@app/ui/components/Button';
import Modal from '@app/ui/components/Modal';

import { useRouter } from 'next/router';
import { FC } from 'react';
import styled from 'styled-components';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
}

const ModalAfterRegistration: FC<Props> = ({ isOpen, className, onClose }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handleEachAction = (action: () => void) => {
    return () => {
      dispatch(actions.allTherapistsModalAfterSignUp.setHasShown(true));

      action();
    };
  };

  const handleChooseTherapist = () => router.push(ROUTES['/client/interview']);

  return (
    <Modal
      className={className}
      isOpen={isOpen}
      onClose={handleEachAction(onClose)}
    >
      <DescriptionWrap>
        <DescriptionText>
          Платформа Поговорим Онлайн может помочь вам в выборе специалиста.
        </DescriptionText>
        <DescriptionText>
          Мы зададим вам несколько вопросов, которые помогут определиться с
          специалистом.
        </DescriptionText>
        <DescriptionText>
          Благодарим за интерес к проекту и время, которое вы проведете с нами!
        </DescriptionText>
      </DescriptionWrap>
      <div>
        <StyledButton isLarge onClick={handleEachAction(onClose)}>
          Выбрать специалиста самостоятельно
        </StyledButton>
        <StyledButton
          isLarge
          styleType="primary"
          onClick={handleEachAction(handleChooseTherapist)}
        >
          Пройти опрос
        </StyledButton>
      </div>
    </Modal>
  );
};

const Title = styled.p`
  ${TYPOGRAPHY.heading3Bold24};
  color: ${COLORS.grayscale700};
  margin-bottom: 16px;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    ${TYPOGRAPHY.headline1Semibold18};
  }
`;

const DescriptionWrap = styled.div`
  margin-bottom: 40px;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    margin-bottom: 32px;
  }
`;

const DescriptionText = styled.p`
  ${TYPOGRAPHY.body1Regular14};
  color: ${COLORS.grayscale600};
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  min-width: auto;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export default ModalAfterRegistration;
